import { createSelector } from 'reselect'
import presentationOriginTypes from 'helpers/enums/presentationOriginTypes'
import viewTypes from 'helpers/enums/viewTypes'

const uiSelector = state => state.ui
const qsSelector = state => state.qs

export default createSelector(
	[uiSelector, qsSelector],
	(ui, qs) => {
		const activityOrigin = qs.presentationOrigin || ui.currentView
		switch (activityOrigin) {
			case presentationOriginTypes.GOALS:
				return presentationOriginTypes.GOALS
			case viewTypes.QUICK_LAUNCH_OEQ_ACTIVITY_CREATION:
			case viewTypes.QUICK_LAUNCH_DRAW_IT_ACTIVITY_CREATION:
				return presentationOriginTypes.QUICK_LAUNCH
			default:
				return presentationOriginTypes.REGULAR
		}

	}
)
